import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-usb",
  "use": "icon-si-glyph-usb-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-usb\" id=\"icon-si-glyph-usb\"><title>1006</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M13.074,3.098 L13.074,4.938 L14.042,4.938 L14.042,6.46 L9.907,7.98 L9.907,2.93 L12,2.921 L9.542,2.27373675e-13 L7.031,2.959 L9.089,2.959 L9.089,10.525 L4.959,9.426 L4.959,7.92 C5.562,7.725 6,7.166 6,6.499 C6,5.671 5.328,4.999 4.5,4.999 C3.672,4.999 3,5.671 3,6.499 C3,7.164 3.436,7.722 4.035,7.918 L4.035,10 L9.089,11.585 L9.089,13.064 C8.462,13.244 8,13.815 8,14.5 C8,15.328 8.672,16 9.5,16 C10.328,16 11,15.328 11,14.5 C11,13.814 10.535,13.241 9.907,13.062 L9.907,9.01 L14.947,7.061 L14.947,4.937 L15.917,4.937 L15.917,3.097 L13.074,3.097 L13.074,3.098 Z\" fill=\"#434343\" class=\"si-glyph-fill\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-usb.svg
// module id = E0Hp
// module chunks = 62